import DevApiDebugPanel from './DevApiDebugPanel';

const DevApiDebugPanelGate = () => {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }
  return <DevApiDebugPanel />;
};

export default DevApiDebugPanelGate;
